import React, { Component, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import { Tooltip } from "@material-ui/core";
import { Alert } from "reactstrap";
import Select from "react-select";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from "reactstrap";
import {
  getApprovedLabs,
  updateMembershipStatus,
  getDeleteParticipant,
} from "store/registration-admin/actions";
import { getParticipantSchemelist } from "store/Payment/actions";
import { getcyclelist } from "store/cycle/actions";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

//Import Breadcrumb
import * as Yup from "yup";
import Breadcrumbs from "components/Common/Breadcrumb";
import {
  getAlldeletedLabs,
  approveUnapproveLab,
} from "store/registration-admin/actions";

import ApproveUnapproveModal from "components/Common/ApproveUnapproveModal";
import "assets/scss/table.scss";
import { countBy } from "lodash";
import EditparticipantsModal from "./editparticipantsModal";
import moment from "moment";

class ParticipantListN extends Component {
  constructor(props) {
    super(props);
    //this.displaySuccessMessage = this.displaySuccessMessage.bind(this);
    this.node = React.createRef();

    this.handleSchemeChange = this.handleSchemeChange.bind(this);
    this.handleSchemeModalOpen = this.handleSchemeModalOpen.bind(this);
    this.handleSchemeModalClose = this.handleSchemeModalClose.bind(this);
    this.state = {
      showModal: false,
      editModal: false,
      selectedParticipant: null,
      AllDeletedLabs: [],
      approvedLabs: [],
      filteredLabs: [],
      ListCity: [],
      selectedProvince: "",
      provinceOptions: [],
      ListDistrict: [],
      ListProvince: [],
      ListDesignation: [],
      ListDepartment: [],
      ListCountry: [],
      ListType: [],
      ListSector: [],
      CycleList: [],
      selectedScheme: null,
      id: "",
      successMessage: "",
      btnText: "Copy",
      organization_name: "",
      isApproved: false,
      unapprovedModal: false,
      tooltipContent: ["Worst", "Bad", "Average", "Good", "Excellent"],
      pendingLabListColumns: [],
      selectedParticipantType: "All Participant",
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",

      pendingLabListColumns: [
        // {
        //   dataField: "id",
        //   text: "ID",
        //   sort: true,
        //   headerStyle: {
        //     textAlign: "center",
        //     backgroundColor: "#a6d4ff", // Light pink for header
        //   },
        //   style: (cell, row) => {
        //     const isPart =
        //       row.payment_settlement?.toString().toLowerCase() === "part";
        //     if (isPart) {
        //       return {
        //         // backgroundColor: "#c20505ff",
        //         color: "#c20505ff",
        //         textAlign: "center",
        //       };
        //     }
        //     return { backgroundColor: "#e0e0e0", textAlign: "center" };
        //   },
        //   filter: textFilter(),
        //   formatter: (cellContent, row) => <>{row.id}</>,
        // },
        {
          dataField: "registered_at",
          text: "Joining Date",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, row) => (
            <>
              {row.registered_at
                ? moment(row.registered_at).format("DD-MMM-YY")
                : "-"}
            </>
          ),
        },
        {
          dataField: "district",
          text: "District",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, AllDeletedLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllDeletedLabs.district}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "city",
          text: "City",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, AllDeletedLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllDeletedLabs.city}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "name",
          text: "Participant",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";

            return (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <Link
                  to="#"
                  onClick={(e) => this.openLabModal(e, row)}
                  style={{
                    cursor: "pointer",
                    color: isPart ? "#c20505ff" : "#007bff", // black if red row, else default blue
                  }}
                >
                  {row.name}
                </Link>
              </span>
            );
          },
        },
        {
          dataField: "lab_staff_name",
          text: "Name",
          sort: true,
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          formatter: (cellContent, AllDeletedLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllDeletedLabs.lab_staff_name}
              </span>
            </>
          ),
          filter: textFilter(),
        },

        {
          dataField: "landline_registered_by",
          text: "Contact No.",
          skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          sort: true,
          formatter: (cellContent, AllDeletedLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllDeletedLabs.landline_registered_by}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "schemes",
          text: "Scheme",
          sort: true, // ✅ Enable sorting
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
            cursor: "pointer",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },
          formatter: (cellContent, lab) => {
            const count = Array.isArray(lab.schemes) ? lab.schemes.length : 0;
            return (
              <Link
                to="#"
                onClick={() => this.handleSchemeModalOpen(lab)}
                style={{ fontWeight: "bold", textDecoration: "underline" }}
              >
                {count > 0 ? `${count}` : "-"}
              </Link>
            );
          },
          sortFunc: (a, b, order) => {
            const countA = Array.isArray(a) ? a.length : 0;
            const countB = Array.isArray(b) ? b.length : 0;
            if (order === "asc") {
              return countA - countB;
            }
            return countB - countA;
          },
          filter: textFilter({
            onFilter: (filterValue, data) => {
              const count = parseInt(filterValue, 10); // convert input to number
              if (isNaN(count)) return data; // if input is not a number, return all
              return data.filter(
                (row) =>
                  Array.isArray(row.schemes) && row.schemes.length === count
              );
            },
          }),
        },
        {
          dataField: "payment_settlement",
          text: "Payment Settlement",
          skipDefaultStyles: true,
          headerStyle: {
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";

            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }

            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },
          filter: textFilter(),
          sort: true,
          formatter: (cellContent, row) => {
            const settlement = (
              row.payment_settlement ??
              row.payment?.settlement ??
              ""
            )
              .toString()
              .trim();

            const remaining = row.remaining_amount ?? "-";

            // Format remaining amount with commas
            const formattedRemaining =
              remaining && !isNaN(remaining)
                ? Number(remaining).toLocaleString()
                : "–";

            const displayText = `${
              settlement && settlement !== "--" ? settlement : "–"
            }${
              settlement === "Part" ? ` (Remaining: ${formattedRemaining})` : ""
            }`;

            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  color: settlement === "Part" ? "#c20505ff" : "black",
                }}
                title={displayText} // <-- tooltip on hover
              >
                <span>
                  {settlement && settlement !== "--" ? settlement : "–"}
                </span>
                {settlement === "Part" && (
                  <span
                    style={{
                      fontSize: "0.85em",
                      color: "#c20505ff",
                    }}
                  >
                    {formattedRemaining}
                  </span>
                )}
              </div>
            );
          },
        },

        {
          dataField: "payment_status",
          text: "Payment Status",
          headerStyle: {
            backgroundColor: "#a6d4ff", // 🔵 light blue for header
            textAlign: "center",
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },
          filter: textFilter(),
          sort: true,
          formatter: (cellContent, AllDeletedLabs) => (
            <>
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {AllDeletedLabs.payment_status}
              </span>
            </>
          ),
          filter: textFilter(),
        },
        {
          dataField: "membership_status",
          text: "Membership Status",
          // skipDefaultStyles: true,
          headerStyle: {
            textAlign: "center",
            backgroundColor: "#a6d4ff", // Light pink for header
          },
          style: (cell, row) => {
            const isPart =
              row.payment_settlement?.toString().toLowerCase() === "part";
            if (isPart) {
              return {
                // backgroundColor: "#c20505ff",
                color: "#c20505ff",
                textAlign: "center",
              };
            }
            return { backgroundColor: "#e0e0e0", textAlign: "center" };
          },

          filter: textFilter(),
          sort: true,
          formatter: (cellContent, AllDeletedLabs) => {
            // Assuming the cycle status is stored in AllDeletedLabs.cycle_status or similar
            const cycleStatus = AllDeletedLabs.cycle_status || ""; // adjust if your key is different

            const displayStatus =
              cycleStatus.toLowerCase() === "active"
                ? "Active"
                : AllDeletedLabs.membership_status
                ? AllDeletedLabs.membership_status
                : "Inactive";

            return (
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                {displayStatus}
              </span>
            );
          },
          filter: textFilter(),
        },
        {
          dataField: "id",
          text: "Action",
          isDummyField: true,
          headerStyle: { textAlign: "center", backgroundColor: "#a6d4ff" },
          style: { backgroundColor: "#e0e0e0", textAlign: "center" },
          formatter: (cell, row) => (
            <div className="d-flex justify-content-center gap-2">
              {/* Recover */}
              <button
                className="btn btn-success btn-sm"
                title="Recover Participant"
                onClick={() => this.handleRecoverParticipant(row)}
              >
                <i className="mdi mdi-refresh font-size-14"></i>
              </button>

              {/* History */}
              {/* <Tooltip title="History">
                <Link
                  to="#"
                  className="text-primary"
                  onClick={e => {
                    e.preventDefault();

                    if (!this.state.organization_name) {
                      console.error("Invalid organization name");
                      return;
                    }

                    const url = `/${this.state.organization_name}/ParticipantDeleteHistory/${row.id}`;
                    this.props.history.push(url);
                  }}
                >
                  <i className="fas fa-comment font-size-16"></i>
                </Link>
              </Tooltip> */}
            </div>
          ),
        },
      ],
    };
    console.log(
      "Initialized user_id:",
      localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "No authUser found in localStorage"
    );

    this.handleApprovedEvent = this.handleApprovedEvent.bind(this);
    this.togglePatientModal = this.togglePatientModal.bind(this);
    this.handleParticipantTypeChange =
      this.handleParticipantTypeChange.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
  }

  // displaySuccessMessage(message) {
  //  alert(message); // Replace this with your desired success message logic
  // }
  // Add this method to your class
  setShowModal = (value) => {
    this.setState({ showModal: value });
  };
  isPaymentModalOpen = (participant) => {
    this.setState(
      {
        isPaymentModalOpen: true,
        selectedParticipant: participant, // Store full participant object
      },
      () => console.log("Modal State Updated:", this.state.selectedParticipant)
    );
  };
  handleDeleteParticipant = (participant) => {
    if (window.confirm("Are you sure you want to delete this participant?")) {
      new Promise((resolve, reject) => {
        this.props.ongetDeleteParticipant(participant.id, resolve, reject);
      })
        .then(() => {
          alert("Participant deleted successfully.");
        })
        .catch((errorMessage) => {
          alert(errorMessage); // Shows: "This participant has an active cycle and cannot be deleted."
        });
    }
  };

  isMembershipModalOpen = (participant) => {
    console.log("Opening Membership Modal for Participant:", participant); // Debug log
    this.setState(
      {
        isMembershipModalOpen: true,
        selectedParticipant: participant, // Store the correct participant
      },
      () =>
        console.log(
          "Membership Modal Opened for:",
          this.state.selectedParticipant
        )
    );
  };

  handleSchemeCountChange = (e) => {
    const selectedSchemeCount = e.target.value;
    this.setState({ selectedSchemeCount }, () => {
      this.applyFilters();
    });
  };

  getMaxSchemeCount = () => {
    const { AllDeletedLabs } = this.state;

    if (!Array.isArray(AllDeletedLabs)) return 0;

    let max = 0;
    AllDeletedLabs.forEach((lab) => {
      const count = Array.isArray(lab.schemes) ? lab.schemes.length : 0;
      if (count > max) max = count;
    });

    return max;
  };

  handleParticipantTypeChange(event) {
    const selectedParticipantType = event.target.value;
    console.log("Selected Participant Type:", selectedParticipantType);

    this.setState({ selectedParticipantType }, () => {
      console.log(
        "Updated selectedParticipantType in state:",
        this.state.selectedParticipantType
      );
      this.applyFilters();
    });
  }

  handleSchemeChange = (event) => {
    const selectedScheme = event.target.value;
    console.log("Scheme selected:", selectedScheme);

    this.setState({ selectedScheme }, () => {
      this.applyFilters(); // Call filters after updating state
    });
    const { organization_name } = this.state; // Extract from state
  };

  applyFilters = () => {
    const {
      AllDeletedLabs,
      selectedParticipantType,
      selectedScheme,
      selectedProvince,
      selectedCycle,
      organization_name,
    } = this.state;

    console.log("Filtering with:", {
      selectedParticipantType,
      selectedScheme,
      selectedProvince,
      selectedCycle,
      AllDeletedLabs,
    });

    const filteredData = AllDeletedLabs.filter((lab) => {
      const membershipStatus = lab.membership_status?.trim().toLowerCase();
      const membershipDetail = lab.membership_status_detail
        ? lab.membership_status_detail.trim().toLowerCase()
        : "";
      let matchesParticipantType = false;

      if (selectedParticipantType === "All Participant") {
        matchesParticipantType = true; // Show all participants
      } else if (selectedParticipantType === "Approved Participant") {
        matchesParticipantType =
          membershipStatus === "active" || membershipDetail === "active"; // Approved or Active participants
      } else if (selectedParticipantType === "Pending Participant") {
        matchesParticipantType = membershipStatus === "pending"; // Pending participants
      } else if (selectedParticipantType === "Unapproved Participant") {
        matchesParticipantType = membershipStatus === "inactive"; // Only participants with "inactive" membership status
      } else if (selectedParticipantType === "Suspended Participant") {
        matchesParticipantType = membershipStatus === "suspended"; // Suspended participants
      } else if (selectedParticipantType === "New Register") {
        matchesParticipantType = membershipStatus === "new register";
      }
      const matchesProvince =
        !this.state.selectedProvince ||
        (lab.province &&
          lab.province.toLowerCase() ===
            this.state.selectedProvince.toLowerCase());
      // 🧠 Match selected scheme
      const matchesScheme =
        !selectedScheme ||
        (Array.isArray(lab.schemes) &&
          lab.schemes.some(
            (s) =>
              String(s.scheme_id) === String(selectedScheme) ||
              String(s.scheme_name) === String(selectedScheme)
          ));

      // 🧩 Match selected cycle (only when selected)
      const matchesCycle =
        !selectedCycle ||
        (Array.isArray(lab.schemes) &&
          lab.schemes.some(
            (s) => s.cycle_id?.toString() === selectedCycle.toString()
          ));

      // ✅ Return labs that match all filters
      // NEW FILTER — scheme count
      const matchesSchemeCount =
        !this.state.selectedSchemeCount ||
        (Array.isArray(lab.schemes) &&
          lab.schemes.length === parseInt(this.state.selectedSchemeCount));

      return (
        matchesParticipantType &&
        matchesScheme &&
        matchesCycle &&
        matchesSchemeCount &&
        matchesProvince
      );
    });

    console.log("Filtered Data:", filteredData);

    // Special handling for "Pending Participant"
    if (selectedParticipantType === "Pending Participant") {
      this.props.history.push(`/${organization_name}/pending-participant`);
      return;
    }

    // Update the filtered list in the state for other participant types
    this.setState({ filteredLabs: filteredData }, () => {
      console.log("Updated filteredLabs:", this.state.filteredLabs);
    });
  };

  applyFiltersFromQueryParams = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const filterType = queryParams.get("filterType");
    const filterValue = queryParams.get("filterValue");

    console.log("Applying filters from query params:", {
      filterType,
      filterValue,
    });

    if (filterType && filterValue) {
      // Update the state based on query parameters
      this.setState(
        {
          selectedParticipantType: filterValue, // Set selected type in state
        },
        () => {
          this.applyFilters(); // Apply filters after updating the state
        }
      );
    }
  };

  handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  };
  toggleMembershipModal = () => {
    this.setState(
      (prevState) => ({
        isMembershipModalOpen: !prevState.isMembershipModalOpen,
      }),
      () => {
        console.log(
          "Modal Toggled, New State:",
          this.state.isMembershipModalOpen
        );
      }
    );
  };
  togglePaymentModal = () => {
    this.setState(
      (prevState) => ({
        isPaymentModalOpen: !prevState.isPaymentModalOpen,
      }),
      () => {
        console.log("Modal Toggled, New State:", this.state.isPaymentModalOpen);
      }
    );
  };
  handleSchemeModalOpen(lab) {
    const uniqueSchemes = [
      ...new Map((lab.schemes || []).map((s) => [s.scheme_name, s])).values(),
    ];

    this.setState({
      showSchemeModal: true,
      selectedSchemes: uniqueSchemes,
      selectedParticipant: lab,
    });
  }

  handleSchemeModalClose() {
    this.setState({
      showSchemeModal: false,
      selectedSchemes: [],
      selectedParticipant: null,
    });
  }

  componentDidMount() {
    console.log("Fetching data...");

    // Retrieve user_id from localStorage
    const authUser = localStorage.getItem("authUser");
    const user_id = authUser ? JSON.parse(authUser).user_id : null;

    if (!user_id) {
      console.error("User ID is missing. Cannot proceed with API calls.");
      return;
    }

    console.log("Retrieved user_id:", user_id);

    // Set user_id in state
    this.setState({ user_id }, () => {
      // Get organization_name from URL params
      const { organization_name } = this.props.match.params || {};
      console.log("organization_name from props:", organization_name);

      if (organization_name) {
        this.setState({ organization_name }, () => {
          console.log("Organization name set:", this.state.organization_name);

          // // Initialize dropdown value
          // this.setInitialDropdownValue();
          this.fetchData(this.state.user_id);
          this.applyFiltersFromQueryParams();
          // Fetch data from APIs
          this.fetchData(user_id);
        });
      } else {
        console.error("Organization name is missing in URL parameters.");
      }
    });
  }
  handleSchemeSelect = (e) => {
    const selectedScheme = e.target.value;

    // If user selects empty (Select Scheme)
    if (!selectedScheme) {
      this.setState({
        selectedScheme: null,
        showCycleFilter: false,
        selectedCycle: null,
        filteredCycleOptions: [],
        filteredLabs: this.state.AllDeletedLabs, // <-- RESET TABLE DATA HERE
      });
      return;
    }

    // If a scheme is selected → continue normal logic
    const filteredCycleOptions = this.state.CycleList.filter(
      (cycle) => String(cycle.scheme_id) === String(selectedScheme)
    );

    this.setState(
      {
        selectedScheme,
        filteredCycleOptions,
        showCycleFilter: true,
        selectedCycle: null,
      },
      () => {
        this.applyFilters(); // <-- Apply your existing filters
      }
    );
  };

  handleCycleSelect = (e) => {
    const selectedCycle = e.target.value;
    this.setState({ selectedCycle }, () => {
      console.log("Selected Scheme:", this.state.selectedScheme);
      console.log("Selected Cycle:", this.state.selectedCycle);
      this.applyFilters();
    });
  };
  // Fetch all required data
  fetchData(user_id) {
    const {
      onGetParticipantPayment,
      ongetApprovedLabs,
      ongetcyclelist,
      onGetPendingLabs,
    } = this.props;

    // Call participant payment API
    onGetParticipantPayment(user_id);
    console.log("onGetParticipantPayment called with user_id:", user_id);

    // Call approved labs API
    ongetApprovedLabs(user_id);
    console.log("ongetApprovedLabs called with user_id:", user_id);

    // Call cycle list API
    ongetcyclelist(user_id);
    console.log("ongetcyclelist called with user_id:", user_id);

    // Call pending labs API
    onGetPendingLabs(user_id);
    console.log("onGetPendingLabs called with user_id:", user_id);
  }

  componentDidUpdate(prevProps, prevState) {
    /* ---------- Simple list sync ---------- */
    if (prevProps.ListCity !== this.props.ListCity) {
      this.setState({ ListCity: this.props.ListCity || [] });
    }

    if (prevProps.ListDistrict !== this.props.ListDistrict) {
      this.setState({ ListDistrict: this.props.ListDistrict || [] });
    }

    if (prevProps.ListProvince !== this.props.ListProvince) {
      this.setState({ ListProvince: this.props.ListProvince || [] });
    }

    if (prevProps.ListDesignation !== this.props.ListDesignation) {
      this.setState({ ListDesignation: this.props.ListDesignation || [] });
    }

    if (prevProps.ListDepartment !== this.props.ListDepartment) {
      this.setState({ ListDepartment: this.props.ListDepartment || [] });
    }

    if (prevProps.ListCountry !== this.props.ListCountry) {
      this.setState({ ListCountry: this.props.ListCountry || [] });
    }

    if (prevProps.ListType !== this.props.ListType) {
      this.setState({ ListType: this.props.ListType || [] });
    }

    if (prevProps.ListSector !== this.props.ListSector) {
      this.setState({ ListSector: this.props.ListSector || [] });
    }

    if (prevState.filteredLabs !== this.state.filteredLabs) {
      console.log("FilteredLabs updated:", this.state.filteredLabs);
    }

    /* ---------- Cycle list sync ---------- */
    if (prevProps.CycleList !== this.props.CycleList) {
      console.log("Updating CycleList in state:", this.props.CycleList);
      this.setState({
        CycleList: Array.isArray(this.props.CycleList)
          ? this.props.CycleList
          : [],
      });
    }

    if (prevProps.PaymentSchemeList !== this.props.PaymentSchemeList) {
      this.setState({
        PaymentSchemeList: Array.isArray(this.props.PaymentSchemeList)
          ? this.props.PaymentSchemeList
          : [],
      });
    }

    /* ---------- Deleted labs update ---------- */
    if (prevProps.AllDeletedLabs !== this.props.AllDeletedLabs) {
      console.log("Updated AllDeletedLabs:", this.props.AllDeletedLabs);

      const deletedLabs = Array.isArray(this.props.AllDeletedLabs)
        ? this.props.AllDeletedLabs
        : [];

      const provinces = [
        ...new Set(deletedLabs.map((lab) => lab.province).filter(Boolean)),
      ];

      console.log("Extracted Provinces:", provinces);

      this.setState(
        {
          AllDeletedLabs: deletedLabs,
          provinceOptions: provinces,
        },
        () => {
          this.applyFilters();
        }
      );
    }

    /* ---------- Filter cycle list for participants ---------- */
    if (
      prevProps.AllDeletedLabs !== this.props.AllDeletedLabs ||
      prevProps.CycleList !== this.props.CycleList
    ) {
      console.log("Filtering CycleList for participants");

      const deletedLabs = Array.isArray(this.props.AllDeletedLabs)
        ? this.props.AllDeletedLabs
        : [];

      const cycleList = Array.isArray(this.props.CycleList)
        ? this.props.CycleList
        : [];

      const participantSchemes = new Set(
        deletedLabs.flatMap((lab) =>
          Array.isArray(lab.schemes)
            ? lab.schemes.map((scheme) => scheme.scheme_name)
            : []
        )
      );

      const filteredCycleList = cycleList.filter((cycle) =>
        participantSchemes.has(cycle.scheme_name)
      );

      this.setState({
        CycleList: cycleList,
        filteredCycleList,
      });
    }
  }

  openPatientModal = (e, arg) => {
    this.setState({
      PatientModal: true,
      email: arg.email,
      landline_registered_by: arg.landline_registered_by,
    });
  };

  // toggleEditModal = (participant = null) => {

  //   this.setState((prev) => ({
  //     editModal: !prev.editModal,
  //     selectedParticipant: participant,
  //   }));
  // };
  toggleEditModal = (participant = null) => {
    this.setState((prev) => ({
      editModal: !prev.editModal,
      selectedParticipant: participant || prev.selectedParticipant, // Keep existing if no new participant
      showModal: participant ? true : !prev.showModal, // Set showModal based on whether we have participant data
    }));
  };

  toggleLabModal = () => {
    this.setState((prevState) => ({
      LabModal: !prevState.LabModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };
  toggleModal = () => {
    this.setState((prevState) => ({
      isModalOpen: !prevState.isModalOpen,
    }));
  };
  openLabModal = (e, arg) => {
    this.setState({
      LabModal: true,
      email: arg.email,
      name: arg.name,
      lab_code: arg.lab_code,
      password_foradmins: arg.password_foradmins,
      shipping_address: arg.shipping_address,
      billing_address: arg.billing_address,
    });
  };
  handleMouseExit = () => {
    this.setState({
      PatientModal: false,
      MarketerModal: false,
      LabModal: false,
      isHovered: false,
    });
  };
  togglePatientModal = () => {
    this.setState((prevState) => ({
      PatientModal: !prevState.PatientModal,
    }));
    this.state.btnText === "Copy"
      ? this.setState({ btnText: "Copied" })
      : this.setState({ btnText: "Copy" });
  };

  handleApprovedEvent = (id) => {
    this.setState({ id: id, isApproved: true, unapprovedModal: true });
  };

  handleUnapprovedEvent = (id) => {
    this.setState({ id: id, isApproved: false, unapprovedModal: true });
  };

  callOnApproveUnapproveLab = () => {
    const { onApproveUnapproveLab, onGetPendingLabs } = this.props;

    const data = {
      id: this.state.user_id,
      labId: this.state.id,
      isApproved: this.state.isApproved,
    };

    // calling to unapprove lab
    onApproveUnapproveLab(data);

    // Calling to update list record
    setTimeout(() => {
      onGetPendingLabs(this.state.user_id);
    }, 1000);

    this.setState({ unapprovedModal: false });
  };

  onPaginationPageChange = (page) => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  exportToExcel = () => {
    const { filteredLabs, selectedScheme } = this.state;

    if (!filteredLabs || filteredLabs.length === 0) {
      console.error("No data available to export.");
      alert("No data available to export.");
      return;
    }

    const selectedFields = [
      { key: "province", label: "Province" },
      { key: "district", label: "District" },
      { key: "city", label: "City" },
      { key: "name", label: "Name" },
      { key: "shipping_address", label: "Address Shipping" },
      { key: "billing_address", label: "Address Billing Address" },
      { key: "lab_code", label: "lab_code" },
      { key: "email", label: "Email" },
      { key: "email_participant", label: "Email of Notification Person" },
      { key: "password_foradmins", label: "password" },
      { key: "lab_staff_name", label: "Name of Notification Person" },
      { key: "lab_staff_designation", label: "Designation" },
      {
        key: "landline_registered_by",
        label: "Contact No of Notification Person",
      },
      { key: "schemes", label: "Schemes" },
      { key: "payment_status", label: "Payment Status" },
      { key: "payment_settlement", label: "Payment Settlement" },
      { key: "membership_status", label: "Membership Status" },
    ];

    const dataToExport = filteredLabs.map((item) => {
      const row = {};
      selectedFields.forEach(({ key, label }) => {
        if (key === "schemes") {
          if (Array.isArray(item.schemes)) {
            const uniqueSchemeNames = [
              ...new Set(item.schemes.map((s) => s.scheme_name)),
            ];
            row[label] = uniqueSchemeNames.join(", ");
          } else {
            row[label] = "N/A";
          }
        } else {
          row[label] = item[key] || "N/A";
        }
      });
      return row;
    });

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const colWidths = Object.keys(dataToExport[0]).map((key) => {
      const maxLength = Math.max(
        key.length,
        ...dataToExport.map((row) =>
          row[key] ? row[key].toString().length : 10
        )
      );
      return { wch: maxLength + 2 };
    });

    ws["!cols"] = colWidths;
    const wb = { Sheets: { Participants: ws }, SheetNames: ["Participants"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    // 🆕 Extract scheme_id and cycle_id from selectedScheme if available
    const [schemeId, cycleId] = (selectedScheme || "").split("-");
    const fileName = schemeId
      ? `Participants_Scheme_${schemeId}_Cycle_${cycleId}.xlsx`
      : "All_Participants.xlsx";

    saveAs(data, fileName);
  };
  refreshPage = () => {
    // call your API or reload data
    this.fetchData(this.state.user_id);
  };
  confirmRecoverParticipant = async () => {
    const { selectedParticipant, user_id, AllDeletedLabs } = this.state;

    if (!selectedParticipant?.id) return;

    const payload = {
      participant: selectedParticipant.id,
      membership_status: "Active",
      added_by: JSON.parse(localStorage.getItem("authUser"))?.user_id,
    };

    try {
      await this.props.onupdateMembershipStatus(user_id, payload);

      // ✅ REMOVE recovered participant locally
      const updatedDeletedLabs = AllDeletedLabs.filter(
        (lab) => lab.id !== selectedParticipant.id
      );

      this.setState({
        AllDeletedLabs: updatedDeletedLabs,
        filteredLabs: updatedDeletedLabs,
        isMembershipModalOpen: false,
        selectedParticipant: null,
      });
    } catch (error) {
      console.error("Recover failed:", error);
    }
  };

  handleRecoverParticipant = (lab) => {
    this.setState({
      selectedParticipant: lab,
      isMembershipModalOpen: true,
    });
  };

  render() {
    console.log("Rendering table with data:", this.state.filteredLabs);
    const { SearchBar } = Search;
    const { ListCity } = this.state;
    const { ListDistrict } = this.state;
    const { ListProvince } = this.state;
    const { ListDesignation } = this.state;
    const { ListDepartment } = this.state;
    const { ListCountry } = this.state;
    const { ListType, ListSector } = this.state;

    const AllDeletedLabs = Array.isArray(this.props.AllDeletedLabs)
      ? this.props.AllDeletedLabs
      : [];
    const data = this.state.data;
    const { onApproveUnapproveLab, onGetPendingLabs } = this.props;
    const { isPaymentModalOpen, togglePaymentModal } = this.props;
    const { isMembershipModalOpen, toggleMembershipModal } = this.props;
    const { filteredLabs, selectedParticipantType, selectedScheme } =
      this.state;

    const pageOptions = {
      sizePerPage: 50,
      totalSize: AllDeletedLabs.length, // replace later with size(AllDeletedLabs),
      custom: true,
    };
    const maxSchemeCount = this.getMaxSchemeCount();
    const schemeCountOptions = Array.from(
      { length: maxSchemeCount },
      (_, i) => i + 1
    );
    // const { isPaymentModalOpen } = this.state;
    const { approvedLabs, CycleList } = this.state;

    const participantOptions = (this.props.approvedLabs || []).map(
      (participant) => ({
        value: participant.id, // ensure this is the correct unique identifier
        label: participant.name, // or any other field you'd like to display
      })
    );
    const schemeOptions = CycleList.map((scheme) => ({
      value: scheme.id, // Use scheme ID instead of scheme name
      label: `(Scheme Name: ${scheme.scheme_name}) - (Cycle Number: ${scheme.cycle_no})`,
    }));

    console.log("Mapped scheme option:", schemeOptions);
    const { isModalOpen, toggleModal, isOpen, toggle, onSubmit } = this.state;
    const defaultSorted = [
      {
        dataField: "id", // if dataField is not match to any column you defined, it will be ignored.
        order: "desc", // desc or asc
      },
    ];
    const customStyles = {
      // <-- This is invalid here
      control: (provided) => ({
        ...provided,
        minHeight: "38px",
      }),
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Pending Labs | External QC</title>
          </MetaTags>

          <ApproveUnapproveModal
            show={this.state.unapprovedModal}
            onYesClick={this.callOnApproveUnapproveLab}
            onCloseClick={() => this.setState({ unapprovedModal: false })}
          />

          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Labs" breadcrumbItem="Lists of Participants" />
            <Row className="justify-content-center align-item-center">
              <Col lg="10">
                <Card>
                  <CardBody>
                    <Row className="justify-content-end">
                      <Col lg="auto" className="text-end">
                        <Button
                          onClick={this.exportToExcel}
                          className="mb-3"
                          disabled={
                            !this.state.AllDeletedLabs ||
                            this.state.AllDeletedLabs.length === 0
                          }
                        >
                          Export to Excel
                        </Button>
                      </Col>
                    </Row>

                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.pendingLabListColumns}
                      data={this.state.filteredLabs}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={this.state.pendingLabListColumns}
                          data={this.state.filteredLabs}
                          search
                        >
                          {(toolkitprops) => (
                            <React.Fragment>
                              <Row className="mb-2">
                                <Col sm="8">
                                  <div className="ms-2 mb-4">
                                    <div className="container">
                                      <div className="row align-items-center">
                                        {/* Filter 1 */}
                                        <div className="col">
                                          <select
                                            className="form-select"
                                            onChange={
                                              this.handleParticipantTypeChange
                                            }
                                            value={
                                              this.state.selectedParticipantType
                                            }
                                            style={{ width: "200px" }}
                                          >
                                            <option value="All Participant">
                                              All Participant
                                            </option>
                                            <option value="Approved Participant">
                                              Approved Participant
                                            </option>
                                            <option value="Unapproved Participant">
                                              Unapproved Participant
                                            </option>
                                            <option value="Pending Participant">
                                              Pending Participant
                                            </option>
                                            <option value="Suspended Participant">
                                              Suspended Participant
                                            </option>
                                          </select>
                                        </div>
                                        {/* Province Filter */}
                                        <div className="col">
                                          <select
                                            className="form-select"
                                            value={this.state.selectedProvince}
                                            onChange={(e) => {
                                              this.setState(
                                                {
                                                  selectedProvince:
                                                    e.target.value,
                                                },
                                                () => {
                                                  this.applyFilters();
                                                }
                                              );
                                            }}
                                            style={{ width: "200px" }}
                                          >
                                            <option value="">
                                              Select Province
                                            </option>
                                            {this.state.provinceOptions.map(
                                              (prov, i) => (
                                                <option key={i} value={prov}>
                                                  {prov}
                                                </option>
                                              )
                                            )}
                                          </select>
                                        </div>

                                        {/* Filter 2 */}
                                        <div className="col">
                                          {/* Scheme Filter */}
                                          <select
                                            className="form-select"
                                            value={
                                              this.state.selectedScheme || ""
                                            }
                                            onChange={(e) =>
                                              this.handleSchemeSelect(e)
                                            }
                                            style={{ width: "250px" }}
                                          >
                                            <option value="">
                                              Select Scheme
                                            </option>
                                            {Array.isArray(
                                              this.state.filteredCycleList
                                            ) &&
                                              [
                                                ...new Map(
                                                  this.state.filteredCycleList.map(
                                                    (item) => [
                                                      String(item.scheme_id), // ensure consistent string key
                                                      item,
                                                    ]
                                                  )
                                                ).values(),
                                              ].map((scheme) => (
                                                <option
                                                  key={scheme.scheme_id}
                                                  value={String(
                                                    scheme.scheme_id
                                                  )} // ensure consistent string comparison
                                                >
                                                  {scheme.scheme_name}
                                                </option>
                                              ))}
                                          </select>
                                        </div>
                                        {/* Filter: Scheme Count */}
                                        <div className="col m-3">
                                          <select
                                            className="form-select"
                                            value={
                                              this.state.selectedSchemeCount
                                            }
                                            onChange={
                                              this.handleSchemeCountChange
                                            }
                                            style={{ width: "200px" }}
                                          >
                                            <option value="">
                                              Scheme Count
                                            </option>

                                            {schemeCountOptions.map((count) => (
                                              <option key={count} value={count}>
                                                {count}
                                                {count > 1 ? "" : ""}
                                              </option>
                                            ))}
                                          </select>
                                        </div>

                                        {/* Show Cycle dropdown only if a Scheme is selected */}
                                        {this.state.showCycleFilter && (
                                          <div className="col m-3">
                                            <select
                                              className="form-select"
                                              value={
                                                this.state.selectedCycle || ""
                                              }
                                              onChange={(e) =>
                                                this.handleCycleSelect(e)
                                              }
                                              style={{ width: "250px" }}
                                            >
                                              <option value="">
                                                Select Cycle
                                              </option>
                                              {this.state.filteredCycleOptions.map(
                                                (cycle) => (
                                                  <option
                                                    key={cycle.id}
                                                    value={cycle.id}
                                                  >
                                                    Cycle {cycle.cycle_no}
                                                  </option>
                                                )
                                              )}
                                            </select>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="mb-2 mt-3">
                                {/* <Col sm="4">
                                  <div className="search-box ms-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitprops.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col> */}
                              </Row>
                              <Row className="mb-4">
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      key={`table-${
                                        Array.isArray(this.state.filteredLabs)
                                          ? this.state.filteredLabs.length
                                          : 0
                                      }`}
                                      keyField="id"
                                      data={this.state.filteredLabs}
                                      columns={this.state.pendingLabListColumns}
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes="table align-middle table-condensed table-hover table-body-white"
                                      bordered={false}
                                      striped={true}
                                      headerWrapperClasses="table-header-grey"
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()}
                                      rowStyle={(row, rowIndex) => {
                                        const isPart =
                                          row.payment_settlement
                                            ?.toString()
                                            .toLowerCase() === "part";
                                        return isPart
                                          ? {
                                              backgroundColor: "#ff7f7f",
                                              color: "black",
                                            } // Entire row #ff7f7f
                                          : {};
                                      }}
                                    />
                                    <Modal
                                      isOpen={this.state.isMembershipModalOpen}
                                      toggle={this.toggleMembershipModal}
                                      className={this.props.className}
                                    >
                                      <ModalHeader
                                        toggle={this.toggleMembershipModal}
                                      >
                                        Recover Participant
                                      </ModalHeader>

                                      <ModalBody>
                                        Are you sure you want to recover{" "}
                                        <strong>
                                          {this.state.selectedParticipant
                                            ?.name || "this lab"}
                                        </strong>
                                        ?
                                      </ModalBody>

                                      <ModalFooter>
                                        <Button
                                          color="success"
                                          onClick={
                                            this.confirmRecoverParticipant
                                          }
                                        >
                                          Yes
                                        </Button>
                                        <Button
                                          color="secondary"
                                          onClick={this.toggleMembershipModal}
                                        >
                                          No
                                        </Button>
                                      </ModalFooter>
                                    </Modal>

                                    <Modal
                                      isOpen={this.state.LabModal}
                                      className={this.props.className}
                                      // onPointerLeave={this.handleMouseExit}
                                    >
                                      <ModalHeader
                                        toggle={this.toggleLabModal}
                                        tag="h4"
                                      >
                                        <strong>
                                          {this.state.name || "Lab Details"}
                                        </strong>
                                      </ModalHeader>

                                      <ModalBody>
                                        <Formik>
                                          <Form>
                                            <Row>
                                              <Col className="col-12">
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Lab Code
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state.lab_code
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      UserName
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={this.state.email}
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Password
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .password_foradmins
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Shipping Address
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .shipping_address
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                                <div className="mb-3 row">
                                                  <div className="col-md-3">
                                                    <Label className="form-label">
                                                      Billing Address
                                                    </Label>
                                                  </div>
                                                  <div className="col-md-9">
                                                    <input
                                                      type="text"
                                                      value={
                                                        this.state
                                                          .billing_address
                                                      }
                                                      className="form-control"
                                                      readOnly={true}
                                                    />
                                                  </div>
                                                </div>
                                              </Col>
                                            </Row>
                                          </Form>
                                        </Formik>
                                      </ModalBody>
                                    </Modal>
                                    <Modal
                                      isOpen={this.state.showSchemeModal}
                                      toggle={this.handleSchemeModalClose}
                                    >
                                      <ModalHeader
                                        toggle={this.handleSchemeModalClose}
                                      >
                                        {this.state.selectedParticipant?.name ||
                                          "Participant"}{" "}
                                        — Purchased Schemes
                                      </ModalHeader>
                                      <ModalBody>
                                        {this.state.selectedSchemes &&
                                        this.state.selectedSchemes.length >
                                          0 ? (
                                          <ul style={{ paddingLeft: "15px" }}>
                                            {this.state.selectedSchemes.map(
                                              (scheme, i) => (
                                                <li key={i}>
                                                  {scheme.scheme_name}
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        ) : (
                                          <p>No schemes found.</p>
                                        )}
                                      </ModalBody>
                                    </Modal>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ParticipantListN.propTypes = {
  match: PropTypes.object,
  AllDeletedLabs: PropTypes.array,
  className: PropTypes.any,
  onGetPendingLabs: PropTypes.func,
  onApproveUnapproveLab: PropTypes.func,
  history: PropTypes.any,
  onAddNewPayment: PropTypes.func,
  onupdateMembershipStatus: PropTypes.func,
  ongetDeleteParticipant: PropTypes.func,
  participantId: PropTypes.func,
  onGetCityList: PropTypes.func,
  onGetDistrictList: PropTypes.func,
  ongetApprovedLabs: PropTypes.func,
  ongetcyclelist: PropTypes.func,
  approvedLabs: PropTypes.array,
  onGetProvinceList: PropTypes.func,
  onGetParticipantPayment: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string, // Ensure 'search' is a string
  }).isRequired, // Make it required if always expected

  CycleList: PropTypes.array,
  PaymentSchemeList: PropTypes.array,
  isPaymentModalOpen: PropTypes.array,
  togglePaymentModal: PropTypes.array,
  isMembershipModalOpen: PropTypes.array,
  toggleMembershipModal: PropTypes.array,
  ListCity: PropTypes.array,
  ListDistrict: PropTypes.array,
  ListProvince: PropTypes.array,
  onGetdesignationlist: PropTypes.func,
  ListDesignation: PropTypes.array,
  onGetDepartmentList: PropTypes.func,
  onGetCountryList: PropTypes.func,
  onGettypelist: PropTypes.func,
  onGetsectorlist: PropTypes.func,
  ListDepartment: PropTypes.array,
  ListCountry: PropTypes.array,
  ListType: PropTypes.array,
  ListSector: PropTypes.array,
};
const mapStateToProps = ({
  Account,
  registrationAdmin,
  ListCity,
  ListDistrict,
  ListProvince,
  CycleList,
  PaymentScheme,
  ListDesignation,
  ListDepartment,
  ListCountry,
  ListType,
  ListSector,
}) => {
  const cycleList = registrationAdmin.CycleList || [];
  const paymentSchemeList = PaymentScheme?.PaymentSchemeList || [];
  // console.log("CycleList in mapStateToProps:", registrationAdmin, CycleList);
  // // console.log("CycleList in mapStateToProps (registrationAdmin):", registrationAdmin.CycleList);
  // console.log("CycleList in mapStateToProps (CycleList):", CycleList.CycleList);
  // console.log("ListCity from props:", ListCity);
  // console.log("ListDistrict from props:", ListDistrict);

  return {
    userID: Account.userID,
    AllDeletedLabs: registrationAdmin.AllDeletedLabs,
    approvedLabs: registrationAdmin.approvedLabs || [],
    CycleList: CycleList.CycleList, // Ensure it never returns undefined
    ListCity: ListCity?.ListCity || [],
    ListDistrict: ListDistrict?.ListDistrict || [],
    ListProvince: ListProvince.ListProvince,
    ListDesignation: ListDesignation.ListDesignation,
    ListDepartment: ListDepartment.ListDepartment,
    ListCountry: ListCountry.ListCountry,
    ListType: ListType.ListType,
    ListSector: ListSector.ListSector,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onApproveUnapproveLab: (data) => dispatch(approveUnapproveLab(data)),
  onGetPendingLabs: (id) => dispatch(getAlldeletedLabs(id)),
  onGetInstrumentTypeList: (id) => dispatch(getSchemelist(id)),
  onAddNewType: (id, createUnit) => dispatch(addNewSchemeList(id, createUnit)),
  onUpdateType: (id, methodlist) =>
    dispatch(updateSchemeList({ id, ...methodlist })),
  onGetParticipantPayment: (id) => dispatch(getParticipantSchemelist(id)),
  ongetApprovedLabs: (id) => dispatch(getApprovedLabs(id)),
  ongetDeleteParticipant: (id, resolve, reject) =>
    dispatch(getDeleteParticipant(id, resolve, reject)),
  ongetcyclelist: (id) => dispatch(getcyclelist(id)),
  onupdateMembershipStatus: (id, status) => {
    console.log("Updating Membership Status - ID:", id, "Status:", status);
    dispatch(updateMembershipStatus({ id, ...status }));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ParticipantListN));
